import { Link } from 'react-router-dom'
import { Input } from '@/components/ui/Input'
import { Instagram, Twitter, Facebook } from 'lucide-react'
import { useSettings } from '@/hooks/useSettings'

export function Footer() {
  const { brand } = useSettings()

  const tagline = brand?.footerTagline || 'Fine fragrances, made to be discovered. Sample first, find your signature, refill forever.'
  const email = brand?.email
  const phone = brand?.phone
  const address = brand?.address
  const instagram = brand?.instagram
  const twitter = brand?.twitter
  const facebook = brand?.facebook

  return (
    <footer className="bg-wd-deep text-white">
      <div className="mx-auto max-w-content px-6 py-16 lg:px-10">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <img
                src="/Little-sky-full-type-crop.png"
                alt="Little Sky"
                className="h-[4.2rem] w-auto object-contain"
              />
            </Link>
            <p className="text-sm leading-relaxed text-white/60">{tagline}</p>
          </div>

          <div>
            <h4 className="mb-5 font-condensed text-xs uppercase tracking-[0.2em] text-white/50">Shop</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li><Link to="/shop" className="hover:text-white">All fragrances</Link></li>
              <li><Link to="/collections" className="hover:text-white">Collections</Link></li>
              <li><Link to="/scent-quiz" className="hover:text-white">Scent quiz</Link></li>
              <li><Link to="/shop" className="hover:text-white">Refills</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-5 font-condensed text-xs uppercase tracking-[0.2em] text-white/50">House</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li><Link to="/about" className="hover:text-white">Our story</Link></li>
              <li><Link to="/journal" className="hover:text-white">Journal</Link></li>
              <li><Link to="/account" className="hover:text-white">Account</Link></li>
              <li><Link to="/order-status" className="hover:text-white">Order status</Link></li>
            </ul>
          </div>

          <div className="space-y-6">
            <h4 className="font-condensed text-xs uppercase tracking-[0.2em] text-white/50">Journal notes</h4>
            <Input
              type="email"
              placeholder="Your email"
              className="border-white/20 text-white placeholder:text-white/40"
              aria-label="Newsletter email"
            />
            <button className="w-full bg-paper py-3 text-xs font-medium normal-case tracking-[0.12em] text-carbon transition-colors hover:bg-wd-orange hover:text-paper">
              Subscribe
            </button>

            {(email || phone || address) && (
              <div className="space-y-1 pt-2 text-xs text-white/60">
                {email && <p><a href={`mailto:${email}`} className="hover:text-white">{email}</a></p>}
                {phone && <p><a href={`tel:${phone}`} className="hover:text-white">{phone}</a></p>}
                {address && <p className="leading-relaxed">{address}</p>}
              </div>
            )}

            <div className="flex gap-4 pt-2">
              {instagram && (
                <a href={instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="text-white/60 hover:text-white">
                  <Instagram className="h-5 w-5" />
                </a>
              )}
              {twitter && (
                <a href={twitter} target="_blank" rel="noreferrer" aria-label="Twitter" className="text-white/60 hover:text-white">
                  <Twitter className="h-5 w-5" />
                </a>
              )}
              {facebook && (
                <a href={facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="text-white/60 hover:text-white">
                  <Facebook className="h-5 w-5" />
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="mt-16 border-t border-white/10 pt-8">
          <div className="flex justify-center">
            <img
              src="/Little-sky-full-type-crop.png"
              alt="Little Sky"
              className="mb-10 h-auto w-full max-w-[89.6rem] object-contain px-4 drop-shadow-lg brightness-0 invert"
            />
          </div>
          <div className="flex flex-col items-center justify-between gap-4 text-xs text-white/40 md:flex-row">
            <p>© 2026 little sky. All rights reserved.</p>
            <div className="flex gap-6">
              <Link to="/privacy" className="hover:text-white">Privacy</Link>
              <Link to="/terms" className="hover:text-white">Terms</Link>
              <Link to="/about" className="hover:text-white">Shipping</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
